import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import BackendErrorMessage from '../../../components/BackendErrorMessage';
import { ProcessoViewModel } from '../../../viewmodel/ProcessoViewModel';

interface IntegracaoSigaModalProps {
  show: boolean;
  processoId: string;
  processoNome: string;
  onClose: () => void;
  onSuccess: () => void;
}

const IntegracaoSigaModal: React.FC<IntegracaoSigaModalProps> = ({
  show,
  processoId,
  processoNome,
  onClose,
  onSuccess
}) => {
  const [loading, setLoading] = useState(true);
  const [hasIntegracaoSiga, setHasIntegracaoSiga] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      loadStatus();
    }
  }, [show, processoId]);

  const loadStatus = async () => {
    try {
      setLoading(true);
      const status = await ProcessoViewModel.consultarIntegracaoSiga(processoId);
      setHasIntegracaoSiga(status);
    } catch (error) {
      toast.error(BackendErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await ProcessoViewModel.alterarIntegracaoSiga(processoId, hasIntegracaoSiga);
      toast.success('Integração SIGA atualizada com sucesso!');
      onSuccess();
      onClose();
    } catch (error) {
      toast.error(BackendErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Integração SIGA</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status"></div>
          </div>
        ) : (
          <>
            <p><strong>Processo:</strong> {processoNome}</p>
            <Form.Group>
              <Form.Check
                type="switch"
                id="integracao-siga-switch"
                label="Habilitar Integração SIGA"
                checked={hasIntegracaoSiga}
                onChange={(e) => setHasIntegracaoSiga(e.target.checked)}
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={loading || saving}>
          {saving ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IntegracaoSigaModal;
